var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickListError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#EFB034"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0325 28C15.0325 20.8379 20.8379 15.0325 28 15.0325C35.162 15.0325 40.9675 20.8379 40.9675 28C40.9675 35.162 35.162 40.9675 28 40.9675C20.8379 40.9675 15.0325 35.162 15.0325 28ZM28 23.0125C28.5509 23.0125 28.9975 23.4591 28.9975 24.01L28.9975 28.9975C28.9975 29.5484 28.5509 29.995 28 29.995C27.4491 29.995 27.0025 29.5484 27.0025 28.9975L27.0025 24.01C27.0025 23.4591 27.4491 23.0125 28 23.0125ZM28 33.985C28.5509 33.985 28.9975 33.5384 28.9975 32.9875C28.9975 32.4366 28.5509 31.99 28 31.99C27.4491 31.99 27.0025 32.4366 27.0025 32.9875C27.0025 33.5384 27.4491 33.985 28 33.985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickListError);
export default __webpack_public_path__ + "static/media/quick_list_error.57500fea489b23123aa984f88b3eeb24.svg";
export { ForwardRef as ReactComponent };